import SprayEventTypeCropGate from 'components/SprayEventTypeCropGate';
import React from 'react';
import { Table, TableRow, TableHeaderCell } from 'semantic-ui-react';

export default class PrintSprayWorksheetCompletionDetailsTableHeader extends React.PureComponent {
    render(): React.ReactElement {
        return (
            <Table.Header>
                <TableRow>
                    <TableHeaderCell>Orchard</TableHeaderCell>
                    <TableHeaderCell>Blocks</TableHeaderCell>
                    <TableHeaderCell>Planted Area (Ha)</TableHeaderCell>
                    <TableHeaderCell>Tanks estimated</TableHeaderCell>
                    <SprayEventTypeCropGate>
                        <React.Fragment>
                            <TableHeaderCell>Application Type</TableHeaderCell>
                            <TableHeaderCell>Starting Row</TableHeaderCell>
                        </React.Fragment>
                    </SprayEventTypeCropGate>
                    <TableHeaderCell>Tanks completed</TableHeaderCell>
                    <TableHeaderCell>Nozzle setup</TableHeaderCell>
                </TableRow>
            </Table.Header>
        );
    }
}
